module.exports = __webpack_public_path__ + "img/laptop_thumb.89f676bf.jpg";